var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C9.48528 0 11.5 2.01472 11.5 4.5V8H12C13.1046 8 14 8.89543 14 10V16C14 17.1046 13.1046 18 12 18H2C0.895431 18 0 17.1046 0 16V10C0 8.89543 0.895431 8 2 8H2.5V4.5C2.5 2.01472 4.51472 0 7 0ZM7 1.5C5.34315 1.5 4 2.84315 4 4.5V8H10V4.5C10 2.84315 8.65685 1.5 7 1.5Z",
    fill: "#F9A01B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockIcon);
export default __webpack_public_path__ + "static/media/padlock-icon.d4053e1679163e98512286abe63645b3.svg";
export { ForwardRef as ReactComponent };